import { reduce } from './reduce.js';
export function toArray() {
    return (data) => {
        return reduce((acc, current) => {
            acc.push(current);
            return acc;
        }, [])(data);
    };
}
